import { render, staticRenderFns } from "./DrawerFooter.vue?vue&type=template&id=79d10988&scoped=true"
import script from "./DrawerFooter.vue?vue&type=script&lang=ts"
export * from "./DrawerFooter.vue?vue&type=script&lang=ts"
import style0 from "./DrawerFooter.vue?vue&type=style&index=0&id=79d10988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d10988",
  null
  
)

export default component.exports